import { render, staticRenderFns } from "./inspectionTaskMap.vue?vue&type=template&id=021505a2&scoped=true"
import script from "./inspectionTaskMap.vue?vue&type=script&lang=js"
export * from "./inspectionTaskMap.vue?vue&type=script&lang=js"
import style0 from "./inspectionTaskMap.vue?vue&type=style&index=0&id=021505a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021505a2",
  null
  
)

export default component.exports